import React from 'react';

interface IconProps {
  className?: string;
}

export const CATEGORIZED_PROMPTS = {
  "Enhance": [
    "Ultra-clear photorealistic detail",
    "Boost cinematic depth & clarity",
    "Hyper-realistic texture refinement",
    "Sharpen intricate fine details"
  ],
  "Light & Color": [
    "Apply dramatic volumetric lighting",
    "Cyberpunk neon color grading",
    "Warm sunset golden hour glow",
    "Vibrant high-contrast visuals"
  ],
  "Style": [
    "Classical oil painting style",
    "Futuristic sci-fi concept art",
    "Ethereal dreamlike atmosphere",
    "Dark moody cinematic noir"
  ],
  "Mutate": [
    "Change the background to space",
    "Add a glowing energy aura",
    "Transform sky to aurora borealis",
    "Swap environment to tropical jungle"
  ]
};

// Flattened list for the scrolling marquee
export const SAMPLE_PROMPTS = Object.values(CATEGORIZED_PROMPTS).flat();

export const Icons = {
  Plus: ({ className = "" }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
  ),
  Upload: ({ className = "" }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
  ),
  Edit: ({ className = "" }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2.69l5.66 5.66a2 2 0 0 1 0 2.83L8.5 20.34a2 2 0 0 1-1.41.59H4v-3.09a2 2 0 0 1 .59-1.41L12 2.69z"/><path d="M19 11h2"/><path d="M11 19h2"/></svg>
  ),
  History: ({ className = "" }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
  ),
  Download: ({ className = "" }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
  ),
  Refresh: ({ className = "" }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/><path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"/><path d="M21 21v-5h-5"/></svg>
  ),
  X: ({ className = "" }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
  ),
  Trash: ({ className = "" }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
  )
};